import { ITrendBucketConfig } from "@backend/src/shared/schemas/schemas";
import { IGetColorArgs, IColorSpec } from "./roomColoringTypes";

const EPS = 1e-9;
const DEFAULT_OPEN_MAX = 1e12;

export const pickNoDataColor = (args: IGetColorArgs, fallbackGray: string): string => {
  const noData = args.colorSpecs?.find((s) => s.id === "NO_DATA")?.fillColor;
  return noData ?? fallbackGray;
};

export const pickColorFromRangedSpecs = (
  value: number | null | undefined,
  specs: IColorSpec[],
  noDataColor: string,
  treatZeroAsNoData: boolean
): string => {
  if (value == null) return noDataColor;
  if (treatZeroAsNoData && value === 0) return noDataColor;

  for (const s of specs) {
    const r = s.range;
    if (!r) continue;
    if (r.minInclusive != null && value < r.minInclusive) continue;
    if (r.minExclusive != null && value <= r.minExclusive) continue;
    if (r.maxInclusive != null && value > r.maxInclusive) continue;
    return s.fillColor;
  }

  return noDataColor;
};

export const colorSpecsToTrendBucketConfig = (
  specs: IColorSpec[]
): ITrendBucketConfig | undefined => {
  const ranged = specs.filter((s) => s.range != null);
  if (ranged.length === 0) return undefined;

  return {
    kind: "ranges",
    ranges: ranged.map((s) => {
      const r = s.range!;
      const min =
        r.minInclusive != null ? r.minInclusive : r.minExclusive != null ? r.minExclusive + EPS : 0;
      const max = r.maxInclusive != null ? r.maxInclusive : DEFAULT_OPEN_MAX;
      return { id: s.id, min, max };
    }),
  };
};

export const roomHasStandardRoom = (args: IGetColorArgs): string | undefined => {
  if (args.room?.rfpMalRom != null && args.room.rfpMalRom !== "") {
    return args.colorSpecs.find((c) => c.id === "spaceBelongToStandardRoom")?.fillColor;
  }

  return args.colorSpecs.find((c) => c.id === "spaceNotBelongToStandardRoom")?.fillColor;
};
